// src/common/bookingStatusConfig.ts

export interface BookingStatusConfig {
  [status: string]: {
    label: string;
    bg: string;
    text: string;
  };
}

export const bookingStatusConfig: BookingStatusConfig = {
  Enquired: {
    label: "Enquired",
    bg: "bg-yellow-100",
    text: "text-yellow-700"
  },
  Booked: {
    label: "Booked",
    bg: "bg-green-100",
    text: "text-green-700"
  },
  Canceled: {
    label: "Canceled",
    bg: "bg-red-100",
    text: "text-red-700"
  }
  // Add more statuses here as needed
};
